<ng-template #loadingTemplate>
  <mat-spinner></mat-spinner>
</ng-template>

<ng-container *ngIf="!loadingWarehouse else loadingTemplate">

  <h1 class="font-light">Gestione Accessi "{{warehouse?.name}}"</h1>

  <div fxLayoutAlign="center center"
       class="border border-blue-info disclaimer-warning mat-background-light p-1 mb-1 mt-1">
    <p [innerHTML]="roleInfoMessage.message">
      <mat-icon [ngStyle]="{'color': '#FFCA36D8'}">warning</mat-icon> &nbsp;
    </p>
  </div>

  <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="matTabChange($event)">
    <mat-tab label="Magazzini">
      <aw-entity-permission-table
        [entity]="{entityName: accessEntityToEntityIdentifierMap[entities.warehouses], entityId: warehouseId}"
      ></aw-entity-permission-table>
    </mat-tab>

    <mat-tab label="Giacenze">
      <aw-entity-permission-table
        [entity]="{entityName: accessEntityToEntityIdentifierMap[entities.itemWarehouses], entityId: warehouseId}"
      ></aw-entity-permission-table>
    </mat-tab>

  </mat-tab-group>


</ng-container>
